module.exports = __webpack_public_path__ + "img/antes_despues_273.a88d9ec5.png";